import Proxy from '../Proxy';

class ActivityProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('activity', parameters);
  }

  orderBaseActivity(uuid, item = {}) {
    return this.submit('get', `${this.endpoint}/orders-base/${uuid}`, item);
  }

  orderComplexActivity(uuid, item = {}) {
    return this.submit('get', `${this.endpoint}/orders-complex/${uuid}`, item);
  }

  estimationComplexActivity(uuid, item = {}) {
    return this.submit('get', `${this.endpoint}/estimations-complex/${uuid}`, item);
  }

  negativeActivity(uuid, item = {}) {
    return this.submit('get', `${this.endpoint}/negatives/${uuid}`, item);
  }

  damageActivity(uuid, item = {}) {
    return this.submit('get', `${this.endpoint}/damages/${uuid}`, item);
  }
}

export default ActivityProxy;
